import { useApiQuery } from 'client/core/network/hooks/useApiQuery';
import { LoaderSpin } from 'client/ui/loader/LoaderSpin';
import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { IWidget } from 'common/schema/widget/Widget';
import React, { useEffect, useState } from 'react';
import { CaptchaWidgetApi } from '../helper/CaptchaWidgetApi';
import { FormWidgetItem } from './wrapper/FormWidgetItem';
import { useFormWidgetProps } from './contextual/useFormWidgetProps';
import { useFormikContext } from 'formik';
import { TextInput } from 'client/ui/form/input/TextInput';
import { Button, Col, Row } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { CaptchaInputWrapper } from 'client/ui/captcha/CaptchaInputWrapper';

interface FormWidgetInputCaptchaViewProps {
  widget: IWidget;
}

export function FormWidgetInputCaptchaView(
  props: FormWidgetInputCaptchaViewProps
) {
  const { widget } = props;

  // Abbiamo un singolo metadato per i campi di tipo file
  const metadata = MetadataLogic.singleFromWidget(widget);
  const name = `values.${metadata.id}`;
  const [inputProps] = useFormWidgetProps(widget);
  const formik = useFormikContext();

  // TODO Refreshare in automatico il captcha quando scade
  const {
    response,
    loading,
    error,
    refetch
  } = useApiQuery(CaptchaWidgetApi.getCaptcha, { data: {} });

  useEffect(() => {
    formik.setFieldValue(`captchaTokens.${metadata.id}`, response?.data?.token);
    formik.setFieldValue(`${name}`, '');
  }, [response?.data?.token]);

  if (!response || loading) return <LoaderSpin full />;

  return (
    <FormWidgetItem name={name} widget={widget} hideSuccess={true}>
      <CaptchaInputWrapper>
        <Col flex="0 0 35px">
          <Button
            type="primary"
            shape="circle"
            icon={<ReloadOutlined />}
            onClick={refetch}
          />
        </Col>
        <Col flex="0 0 150px">
          {/** Rendering dell'svg */}
          <div dangerouslySetInnerHTML={{ __html: response?.data?.captcha }} />
        </Col>
        <Col flex="1 1 auto">
          <TextInput
            name={name}
            placeholder={widget.input!.placeholder}
            {...inputProps}
          />
        </Col>
      </CaptchaInputWrapper>
    </FormWidgetItem>
  );
}
